export default __webpack_public_path__ + "static/media/Roboto-LightItalic.73fd4dfb.ttf";